import { useParams } from "react-router-dom";
import { SubTaskDetailsPageHeader, SubTaskDetailsForm } from "./components";

export default function SubTaskDetails() {
  const { id, id2 } = useParams();

  return (
    <div className="d-flex flex-column gap-10 p-10">
      <SubTaskDetailsPageHeader id={id} id2={id2} />
      <SubTaskDetailsForm id={id} id2={id2} />
    </div>
  );
}
